module.exports = __webpack_public_path__ + "img/model_44_ug.fc4d7995.jpg";